import React, { useContext } from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/Seo"
import { I18nextContext } from "gatsby-plugin-react-i18next"
import { GatsbyImage } from "gatsby-plugin-image"
import PortableText from "../components/PortableText"
import { AiOutlineCalendar } from "react-icons/ai"
import { BiTimer } from "react-icons/bi"
import Moment from "react-moment"
import "moment-timezone"

const Timetable = ({ data }) => {
  const { language } = useContext(I18nextContext)
  const { blockOne, title } = data.sanityTimetable

  return (
    <Layout>
      <Seo lang={language} title={title[language]} />
      <div className="max-w-screen-xl mx-auto">
        <div className="grid3">
          <div className="col-span-3 sm:col-span-1">
            <figure>
              <GatsbyImage
                image={
                  blockOne.thumbnail.asset?.localFile.childImageSharp
                    .gatsbyImageData
                }
                className="rounded"
                alt={blockOne.thumbnail.attribution || "Minä voin"}
              />
              {blockOne.thumbnail.caption !== null && (
                <figcaption className="text-gray-900 pt-2">
                  {blockOne.thumbnail.caption[language]}
                </figcaption>
              )}
            </figure>
          </div>
          <div className="col-span-3 sm:col-span-2">
            <h1>{blockOne.header[language]}</h1>
            <hr />
            <PortableText textData={blockOne._rawBody[language]} />
            <section>
              <h2>{blockOne.header[language]}</h2>
              <hr />
              {data.allSanityMeeting.nodes.map(meeting => {
                return (
                  <div
                    key={meeting.id}
                    className="last:col-span-4 col-span-4 sm:col-span-4 md:col-span-4 lg:col-span-2 p-5 mb-5 border-l-2 border-red-600 transition-all duration-150 bg-white rounded shadow hover:shadow-lg"
                  >
                    <h3>{meeting.title[language]}</h3>
                    <section className="font-body font-semibold">
                      <span className="flex">
                        <AiOutlineCalendar />
                        <Moment
                          locale={language}
                          format="D MMM YYYY @HH:MM"
                          withTitle
                          className="pl-3"
                        >
                          {meeting.eventStartsAt}
                        </Moment>
                      </span>
                      <span className="flex">
                        <BiTimer />
                        <Moment
                          className="pl-3"
                          format="HH:MM:SS"
                          duration={meeting.eventStartsAt}
                        >
                          {meeting.eventEndsAt}
                        </Moment>
                      </span>
                    </section>
                    <hr />
                    <p className="font-body">HOST: {meeting.author.name}</p>

                    <small className="font-body uppercase text-xl">
                      {meeting.price}
                    </small>
                  </div>
                )
              })}
            </section>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    sanityTimetable {
      title {
        en
        fi
      }
      blockOne {
        _rawBody(resolveReferences: { maxDepth: 10 })
        header {
          en
          fi
        }
        thumbnail {
          asset {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          attribution
          caption {
            en
            fi
          }
        }
      }
    }
    allSanityMeeting(sort: { fields: eventStartsAt, order: DESC }) {
      nodes {
        title {
          en
          fi
        }
        slug {
          current
        }
        eventStartsAt
        eventEndsAt
        categories {
          title
        }
        author {
          name
        }
        price
        id
      }
    }
  }
`
export default Timetable
